import styled from "styled-components";

export const Container = styled.div`
    padding: 20px;
    width: 100%;
    display: grid;
    gap: 24px;
    grid-template-columns: 384px 1fr;
    overflow: hidden;

    > * {
        min-width: 0;
    }

    @media (max-width: 1200px) {
        grid-template-columns: 1fr;
        gap: 16px;
    }

    @media (max-width: 850px) {
        padding: 16px 12px;
        gap: 16px;
    }

    @media (max-width: 640px) {
        padding: 12px 8px;
        gap: 12px;
    }
`;
